<template>
  <SelectPicker
      ref="selectPickerReference"
    v-model="selected"
    api-value="/api/languages/search?query="
    :placeholder-value="placeholderValue"
    :label="label"
  />
</template>

<script setup>
import { ref, watch } from 'vue';
import SelectPicker from '@/ComponentsDeprecated/Select/SelectPicker';

const props = defineProps({
  modelValue: {
    type: String,
    required: false,
    default: null,
  },
  placeholderValue: {
    type: String,
    required: false,
    default: 'Select Language',
  },
  label: {
    type: String,
    required: false,
    default: 'Select Language',
  },
});

const emit = defineEmits({ update: (_value) => true });
const selected = ref(props.modelValue);
const selectPickerReference = ref()

watch(selected, () => {
  emit('update:modelValue', selected.value);
});

function removeSelected() {
    selectPickerReference.value.resetSelected()
}

defineExpose({ removeSelected })





</script>
